export enum RegisterMutations {
  RESET = "RESET",
  SET_BIRTHDATE = "SET_BIRTHDATE",
  SET_SIGNIN_FB = "SET_SIGNIN_FB",
}
